const Cards = (props) => {
  return (
    <div className="grow z-10">
      <div className="even:mx-2 my-2 rounded-md p-[2px] bg-gradient-to-r from-accent via-[#1C8D8E] to-[#2A5E6F] hover:scale-105 duration-200">
        <span className="block text-m text-white rounded-md bg-bg-primary object-fill">
          <iframe
            src={props.url}
            className="w-full h-[250px] object-fill rounded-md"
            allow="autoplay"
            title={props.title}
            data-twe-lazy-load-init
          ></iframe>
        </span>
      </div>
    </div>
  );
};

export default Cards;
